module.exports = __webpack_public_path__ + "img/3.c45a5366.svg";